import React, { useState } from "react";
import { useSelector } from "react-redux";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { loggedInUserProfileSelector } from "../../../auth/selectors";
import ShortcutIcon from "@mui/icons-material/Shortcut";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  Stack,
  Typography,
  styled,
  useMediaQuery,
} from "@mui/material";
import DialogHeader from "app/components/common/DialogHeader";
import TextFieldLabel from "app/components/common/TextFieldLabel";
import {
  CustomTextField,
  CustomTextFieldMultiline,
} from "assets/styles/globalStyledComponent";
import { LoadingButton } from "@mui/lab";
import { useMutation, useQuery } from "react-query";
import // applyToSchoolLogic,
// getAllJoinedSchoolLogic,
// verifySchoolCodeLogic,
// withdrawJoinedSchoolRequestLogic,
"app/services/management";
import { toast } from "react-toastify";
import {
  WithdrawJoiningRequest,
  getAllJoiningRequestByPersonDocId,
  getSchoolInfoByCode,
  schoolApplyByStaff,
} from "app/services/schoolService/user.service";

const ApplySchool = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [state, setState] = useState({
    applyCodeModal: false,
    schoolCode: "",
    schoolDetail: null,
    message: "",
    requestedSchoolData: [],
    withdrawModel: null,
  });

  const handleCloseApplyModal = () => {
    setState((prev) => ({
      ...prev,
      applyCodeModal: false,
      message: "",
      schoolCode: "",
      schoolDetail: null,
    }));
  };
  // LoggedIn Profile
  let loggedInUserProfile = useSelector(loggedInUserProfileSelector);

  const {
    mutate: verifyMutate,
    isLoading: verifySchoolCodeLoading,
    refetch: verifySchoolCodeFetch,
  } = useMutation(getSchoolInfoByCode, {
    onSuccess: ({ data }) => {
      setState((prev) => ({
        ...prev,
        schoolDetail: data?.obj,
      }));
      toast.success(data?.message);
    },
    onError: (err) => {
      toast.error(err?.response?.data?.message);
    },
    enabled: false,
    retry: false,
  });
  const {
    isLoading: getAllJoinedSchoolLoading,
    refetch: getAllJoinedSchoolFetch,
  } = useQuery({
    queryKey: ["getAllJoinedSchool"],
    queryFn: () => getAllJoiningRequestByPersonDocId(),
    onSuccess: ({ data }) => {
      if (data?.list && data?.list?.length === 0) {
        setState((prev) => ({ ...prev, applyCodeModal: true }));
      } else {
        setState((prev) => ({
          ...prev,
          requestedSchoolData: data?.list,
        }));
      }
    },
    onError: ({ response: { data } }) => {
      toast.error(data?.message);
    },
  });
  const {
    isLoading: withdrawJoinedSchoolRequestLoading,
    refetch: withdrawJoinedSchoolRequestFetch,
  } = useQuery({
    queryKey: ["withdrawJoinedSchoolRequest"],
    queryFn: () =>
      WithdrawJoiningRequest({ requestDocId: state.withdrawModel }),
    onSuccess: ({ data }) => {
      setState((prev) => ({
        ...prev,
        withdrawModel: null,
      }));
      toast.success(data?.message);
      getAllJoinedSchoolFetch();
    },
    onError: ({ response: { data } }) => {
      toast.error(data?.message);
    },
    enabled: false,
    retry: false,
  });
  const { mutate: applyToSchool, isLoading: applyToSchoolLoading } =
    useMutation(schoolApplyByStaff, {
      onSuccess: ({ data }) => {
        toast.success(data?.message);
        handleCloseApplyModal();
        getAllJoinedSchoolFetch();
      },
      onError: ({ response: { data } }) => {
        toast.error(data?.message);
      },
    });

  return (
    <>
      <Dialog open={getAllJoinedSchoolLoading}>
        <CircularProgress size={30} sx={{ m: 2 }} />
      </Dialog>
      {/* apply school dialog */}
      <Dialog
        open={state.applyCodeModal}
        fullScreen={isMobile}
        PaperProps={{
          sx: { minWidth: isMobile ? "100%" : "400px" },
        }}
      >
        <DialogHeader title="Apply" handleClose={handleCloseApplyModal} />
        <DialogWrapper>
          {state.schoolDetail ? (
            <>
              <Box className="cover_img__wrapper">
                {/* cover photo */}
                <img
                  src={
                    state.schoolDetail?.coverPhoto ?? "/banner-placeholder.png"
                  }
                  alt="ekalsutra-school-cover"
                />
                {/* logo */}
                <Stack
                  direction="row"
                  justifyContent="center"
                  className="logo_container"
                  sx={{ width: "100%" }}
                >
                  <Box className="logo_wrap">
                    <img
                      src={
                        state.schoolDetail?.schoolLogo ??
                        "image-placeholder.jpeg"
                      }
                      alt="school logo"
                    />
                  </Box>
                </Stack>
              </Box>
              <Box className="location_container">
                <Stack
                  direction="row"
                  alignItems="center"
                  sx={{ px: 2 }}
                  gap={1}
                >
                  <LocationOnIcon sx={{ color: "#0D2553", opacity: 0.5 }} />
                  <Typography className="location_text">
                    {state.schoolDetail?.schoolAddress?.address},{" "}
                    {state.schoolDetail?.schoolAddress?.dist},{" "}
                    {state.schoolDetail?.schoolAddress?.state},{" "}
                    {state.schoolDetail?.schoolAddress?.pinCode}
                  </Typography>
                </Stack>
              </Box>
              <CustomTextFieldMultiline
                fullWidth
                placeholder="Write your message here..."
                value={state.message}
                multiline
                maxRows={5}
                minRows={5}
                onChange={(e) =>
                  setState((prev) => ({ ...prev, message: e.target.value }))
                }
                sx={{ mt: 1, mb: 2, fontSize: "15px" }}
              />
              <DialogActions>
                <LoadingButton
                  variant="contained"
                  color="secondary"
                  size="large"
                  sx={{ width: "40%" }}
                  loading={applyToSchoolLoading}
                  onClick={() =>
                    applyToSchool({
                      schoolCode: state.schoolCode,
                      requestedFor: state.message,
                    })
                  }
                >
                  Apply
                </LoadingButton>
              </DialogActions>
            </>
          ) : (
            <>
              <TextFieldLabel title="Enter School Code" />
              <CustomTextField
                sx={{ width: "70%", mt: 0.5, mb: 2 }}
                placeholder="Type school code"
                size="small"
                value={state.schoolCode}
                onChange={(e) =>
                  setState((prev) => ({ ...prev, schoolCode: e.target.value }))
                }
              />
              <DialogActions>
                <LoadingButton
                  variant="contained"
                  disabled={!state.schoolCode}
                  color="secondary"
                  size="large"
                  sx={{ width: "40%" }}
                  loading={verifySchoolCodeLoading}
                  onClick={() => verifyMutate(state.schoolCode)}
                >
                  Search
                </LoadingButton>
              </DialogActions>
            </>
          )}
        </DialogWrapper>
      </Dialog>
      {/* withdraw dialog */}
      <Dialog
        open={state.withdrawModel}
        PaperProps={{
          sx: { minWidth: isMobile ? "100%" : "300px" },
        }}
      >
        <DialogHeader
          title="Withdraw Application"
          handleClose={() =>
            setState((prev) => ({ ...prev, withdrawModel: null }))
          }
        />
        <Box sx={{ p: 2 }}>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "26px",
              color: (theme) => theme.palette.primary.main,
              textAlign: "center",
              my: 2,
            }}
          >
            Are you sure want to withdraw your Application
          </Typography>
          <Stack direction="row" justifyContent="center" gap={2}>
            <Button
              color="secondary"
              variant="outlined"
              size="large"
              sx={{ width: "30%" }}
              onClick={() =>
                setState((prev) => ({ ...prev, withdrawModel: null }))
              }
            >
              No
            </Button>
            <LoadingButton
              loading={withdrawJoinedSchoolRequestLoading}
              color="secondary"
              variant="contained"
              size="large"
              sx={{ width: "30%" }}
              onClick={() => withdrawJoinedSchoolRequestFetch()}
            >
              Yes
            </LoadingButton>
          </Stack>
        </Box>
      </Dialog>
      <Wrapper>
        <Container maxWidth="lg">
          <Typography className="top_title">
            Welcome back,{" "}
            {loggedInUserProfile?.firstName +
              " " +
              loggedInUserProfile?.lastName}
          </Typography>
          <Typography className="subtitle_text">
            Please select the institute you want to proceed with!
          </Typography>
          <Box className="not_access_box">
            <Stack
              direction={{ xs: "column", sm: "row" }}
              justifyContent="space-between"
              alignItems={{ xs: "stretch", sm: "center" }}
              spacing={{ xs: 2, sm: 0 }}
            >
              <Typography className="applied_text">Applied</Typography>
              <Button
                color="secondary"
                variant="outlined"
                size={isMobile ? "medium" : "large"}
                onClick={() =>
                  setState((prev) => ({ ...prev, applyCodeModal: true }))
                }
                sx={{
                  textTransform: "capitalize",
                  backgroundColor: "#fff",
                }}
              >
                Apply to Institute
              </Button>
            </Stack>
            {state.requestedSchoolData?.map((item, ind) => (
              <Box className="applied_school_card__wrap" key={ind}>
                <Stack direction="row" gap={1}>
                  <Box>
                    <img
                      className="logo"
                      src={item?.schoolLogo ?? "image-placeholder.jpeg"}
                      alt="school logo"
                    />
                  </Box>
                  <Box>
                    <Stack direction="row" justifyContent="space-between">
                      <Typography className="school_name">
                        {item?.schoolName}
                      </Typography>
                      {item?.status === "REQUESTED" && (
                        <Stack direction="row" alignItems="center" gap={1.5}>
                          <ShortcutIcon
                            sx={{
                              transform: "rotate(180deg)",
                              cursor: "pointer",
                            }}
                            color="error"
                            onClick={() =>
                              setState((prev) => ({
                                ...prev,
                                withdrawModel: item?._id,
                              }))
                            }
                          />
                          <Box className="requested_button">
                            <Typography className="text">REQUESTED</Typography>
                          </Box>
                        </Stack>
                      )}
                      {item?.status === "APPROVED" && (
                        <Box className="approved_button">
                          <Typography className="text">APPROVED</Typography>
                        </Box>
                      )}
                      {item?.status === "WITHDRAWN" && (
                        <Box className="withdraw_button">
                          <Typography className="text">WITHDRAWN</Typography>
                        </Box>
                      )}
                    </Stack>
                    <Stack
                      direction="row"
                      gap={0.5}
                      alignItems="center"
                      sx={{ my: 1 }}
                    >
                      <LocationOnIcon sx={{ color: "#0D2553" }} />
                      <Typography className="location_text">
                        {item?.schoolAddress?.address},{" "}
                        {item?.schoolAddress?.dist},{" "}
                        {item?.schoolAddress?.state},{" "}
                        {item?.schoolAddress?.pinCode}
                      </Typography>
                    </Stack>
                    <Typography>{item?.requestedFor}</Typography>
                  </Box>
                </Stack>
              </Box>
            ))}
          </Box>
        </Container>
      </Wrapper>
    </>
  );
};

export default ApplySchool;
const Wrapper = styled(Box)`
  margin-top: 80px;
  overflow-y: auto;
  height: calc(100vh - 120px);
  width: 100%;

  .top_title {
    margin-top: 20px;
    font-weight: 700;
    font-size: 30px;
    text-align: center;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    color: #0c2f49;

    @media (max-width: 768px) {
      font-size: 22px;
      margin-top: 10px;
    }

    @media (max-width: 480px) {
      font-size: 18px;
    }
  }

  .subtitle_text {
    font-weight: 500;
    font-size: 18px;
    text-align: center;
    color: #0c2f49;
    margin-top: 14px;

    @media (max-width: 768px) {
      font-size: 16px;
      margin-top: 10px;
      padding: 0 16px;
    }

    @media (max-width: 480px) {
      font-size: 14px;
    }
  }

  .not_access_box {
    background: #fbfbff;
    border: 1px solid rgba(61, 57, 137, 0.1);
    box-shadow: 0px 4px 10px rgba(61, 57, 137, 0.05);
    border-radius: 20px;
    max-width: 600px;
    width: 100%;
    margin: 20px auto;
    padding: 10px;

    @media (max-width: 768px) {
      max-width: 100%;
      margin: 16px 0;
      border-radius: 16px;
      padding: 12px;
    }

    @media (max-width: 480px) {
      border-radius: 12px;
      padding: 8px;
    }
  }
  .not_access_text {
    font-weight: 700;
    font-size: 34.1191px;
    text-align: center;
    letter-spacing: 0.03em;
    color: #0c2f49;

    @media (max-width: 768px) {
      font-size: 24px;
    }

    @media (max-width: 480px) {
      font-size: 20px;
    }
  }

  .applied_text {
    font-weight: 700;
    font-size: 25px;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    color: #0c2f49;

    @media (max-width: 768px) {
      font-size: 18px;
    }

    @media (max-width: 480px) {
      font-size: 16px;
    }
  }
  .applied_school_card__wrap {
    background: #ffffff;
    border: 1px solid #b6c8d6;
    border-radius: 15px;
    padding: 15px;
    margin-top: 15px;

    @media (max-width: 768px) {
      padding: 12px;
      border-radius: 12px;
    }

    @media (max-width: 480px) {
      padding: 10px;
    }

    .logo {
      height: 100px;
      width: 100px;
      object-fit: contain;
      border-radius: 10px;

      @media (max-width: 768px) {
        height: 80px;
        width: 80px;
      }

      @media (max-width: 480px) {
        height: 60px;
        width: 60px;
      }
    }

    .school_name {
      font-weight: 500;
      font-size: 18px;
      color: #0d2553;

      @media (max-width: 768px) {
        font-size: 16px;
      }

      @media (max-width: 480px) {
        font-size: 14px;
      }
    }

    .location_text {
      font-weight: 500;
      font-size: 14px;
      color: #0d2553;
      max-width: 400px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      @media (max-width: 768px) {
        max-width: 300px;
        font-size: 13px;
      }

      @media (max-width: 480px) {
        max-width: 200px;
        font-size: 12px;
      }
    }
    .requested_button {
      background: rgba(227, 164, 0, 0.05);
      border: 1.15293px solid rgba(227, 164, 0, 0.2);
      border-radius: 20px;
      min-width: 96.63px;
      height: 30.16px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 8px;

      @media (max-width: 480px) {
        min-width: 80px;
        height: 26px;
        border-radius: 16px;
      }

      .text {
        font-weight: 600;
        font-size: 12.8066px;
        text-align: center;
        color: #e3a400;
        white-space: nowrap;

        @media (max-width: 480px) {
          font-size: 11px;
        }
      }
    }

    .approved_button {
      background: rgba(41, 219, 91, 0.15);
      border: 1.15293px solid rgba(7, 177, 3, 0.2);
      border-radius: 20px;
      min-width: 96.63px;
      height: 30.16px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 8px;

      @media (max-width: 480px) {
        min-width: 80px;
        height: 26px;
        border-radius: 16px;
      }

      .text {
        font-weight: 600;
        font-size: 12.8066px;
        text-align: center;
        color: #29db5b;
        white-space: nowrap;

        @media (max-width: 480px) {
          font-size: 11px;
        }
      }
    }

    .withdraw_button {
      background: #fff;
      border: 1.15293px solid #0c2f49;
      border-radius: 20px;
      min-width: 96.63px;
      height: 30.16px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 8px;

      @media (max-width: 480px) {
        min-width: 80px;
        height: 26px;
        border-radius: 16px;
      }

      .text {
        font-weight: 600;
        font-size: 12.8066px;
        text-align: center;
        color: #0b1f32;
        white-space: nowrap;

        @media (max-width: 480px) {
          font-size: 11px;
        }
      }
    }
  }
`;
const DialogWrapper = styled(Box)`
  padding: 20px;

  @media (max-width: 768px) {
    padding: 16px;
  }

  @media (max-width: 480px) {
    padding: 12px;
  }

  .cover_img__wrapper {
    width: 100%;
    height: 130px;
    margin: 10px auto;
    position: relative;

    @media (max-width: 480px) {
      height: 100px;
    }

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 10px;
    }

    .logo_container {
      position: absolute;
      bottom: 0;

      .logo_wrap {
        width: 82.17px;
        height: 82.17px;
        background: #f6f8fc;
        border: 1px solid rgba(182, 200, 214, 0.2);
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: -40px;

        @media (max-width: 480px) {
          width: 70px;
          height: 70px;
          margin-bottom: -35px;
        }
      }

      img {
        width: 50px;
        height: 50px;

        @media (max-width: 480px) {
          width: 40px;
          height: 40px;
        }
      }
    }
  }

  .location_container {
    min-height: 46px;
    background: #ffffff;
    border: 1px solid #b6c8d6;
    border-radius: 8px;
    margin-top: 50px;
    display: flex;
    align-items: center;
    padding: 8px 0;

    @media (max-width: 480px) {
      margin-top: 40px;
      min-height: 40px;
    }

    .location_text {
      font-weight: 500;
      font-size: 14px;
      color: #0d2553;
      opacity: 0.5;

      @media (max-width: 480px) {
        font-size: 12px;
      }
    }
  }
`;
